
import { MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ValidationProblem } from 'src/app/_utils/_validators/_models/validation-problem';


export class SnackBarSuccessConfig extends MatSnackBarConfig
{
    duration = 3000;
    verticalPosition: MatSnackBarVerticalPosition = 'bottom';
    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    panelClass: string = 'sego-snackbar-success';
    successMsg = {
        default: "Datos guardados.",
    }

    getSuccessMsg(key: string): string
    {
        if (this.successMsg[key])
        {
            return this.successMsg[key];
        }
        else
        {
            return this.successMsg["default"];
        }
    }
}

export class SnackBarErrorConfig extends MatSnackBarConfig
{
    duration = 3000;
    verticalPosition: MatSnackBarVerticalPosition = "bottom";
    horizontalPosition: MatSnackBarHorizontalPosition = "center";
    panelClass: string = 'sego-snackbar-error';
    errorMsg = {
        default: "Ha ocurrido un error en el servidor, por favor intentalo en unos instantes",
        sessionExpirada: "Sesión expirada. Inicia sesión nuevamente.",
    }

    getErrorMsg(key: string = null): string
    {
        if (this.errorMsg[key])
        {
            return this.errorMsg[key];
        }
        else if (key == "default" || !key)
        {
            return this.errorMsg["default"];
        }
        else
        {
            return key;
        }
    }

    getValidationProblemMsg(validationProblem: ValidationProblem): string
    {
        if (validationProblem.error?.detail)
        {
            return validationProblem.error.detail;
        }
        else
        {
            return this.errorMsg.default;
        }
    }
}
